import React from 'react';

import ProfileAvatar from 'components/ProfileAvatar';
import ProfileLink from 'components/ProfileLink';

import {formatCommentDate} from 'utils/amateurFilms';

export default function FilmAmateurComment({className = '', comment}) {
    let {user} = comment;

    return (
        <div className={className}>
            <div className="text-item">
                <ProfileAvatar user={user}/>
                <div className="user-date">
                    <ProfileLink user={user} showGender/>
                    <span className="date">{formatCommentDate(comment)}</span>
                </div>
                <div className="message-item">
                    <p>{comment.comment}</p>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/materialPage/comment.js